var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMFooterBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 312,
    viewBox: "0 0 390 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2036_22984)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 312,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.996 146.533C486.467 84.4033 435.673 34.4702 373.543 35.0042C311.413 35.5383 261.476 86.3373 262.004 148.467C262.533 210.597 313.327 260.53 375.457 259.996C437.587 259.462 487.524 208.663 486.996 146.533ZM433.498 146.336C433.214 112.895 406.017 86.0169 372.753 86.3028C339.488 86.5888 312.753 113.93 313.037 147.371C313.322 180.813 340.518 207.69 373.783 207.404C407.047 207.118 433.782 179.777 433.498 146.336Z",
    fill: "url(#paint0_linear_2036_22984)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2036_22984",
    x1: 408.545,
    y1: 35,
    x2: 347.167,
    y2: 255.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5514"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2036_22984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 312,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMFooterBg);
export default __webpack_public_path__ + "static/media/mFooterBg.061bc16deefd1b1a812c6bd38769a1dd.svg";
export { ForwardRef as ReactComponent };